module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Clothes/Briefcase-7701e9338f49bf13c38fcc7f62b998f4.svg";